import React from 'react'

import { AlarmDetails } from 'plugin-codaf-risk-ext-bowtie/BowtieManagment/components/AssetSelector/components/AlarmList/components/AlarmDetails/AlarmDetails'
import { IBowtie } from 'plugin-codaf-risk-ext-bowtie/types'
import { IAlarmEvent } from 'plugin-codaf-risk-ext-bowtie/types/alarms'

import { IOverviewAlarmEvent } from '../../../AssetSelector/AssetSelector'
import { DashboardAlarmDetailsContainer } from './styles'

interface IProps {
    alarmData: IOverviewAlarmEvent
    alarms: Map<number, IAlarmEvent>
    alarmBowties: IBowtie[]
    setAlarmData: (k: IOverviewAlarmEvent) => void
}

export const DashboardAlarmDetails: React.FC<IProps> = ({ setAlarmData, alarmData, alarms, alarmBowties }) => {
    return (
        <DashboardAlarmDetailsContainer>
            <AlarmDetails setAlarm={setAlarmData} alarm={alarmData} alarms={alarms} alarmBowties={alarmBowties} />
        </DashboardAlarmDetailsContainer>
    )
}
